import { useState } from 'react';
import { useTranslations } from 'next-intl';
import { CollapsablePanel } from '@app/app/_components/CollapsablePanel/CollapsablePanel';
import { Heading } from '@app/app/_components/Heading/Heading';
import { ReadOnlyField } from '@app/app/_components/ReadOnlyField/ReadOnlyField';
import { TextButton } from '@app/app/_components/TextButton/TextButton';
import { formatEuroValue } from '@app/infrastructure/application/formatEuroValue';
import { HomeInsuranceRiskPackage } from '@app/domain/model/eshop/home/HomeInsuranceRiskPackage';
import { UpdateModal } from '@app/app/esales/transport/components/UpdateModal';
import { useAppParameters } from '@app/app/_context/AppParametersContext/useAppParameters';

interface Props {
    selectedRisk: HomeInsuranceRiskPackage;
    totalPrice: number;
    onEdit: () => void;
}

export function InsuranceConditionsPanel({ selectedRisk, totalPrice, onEdit }: Props) {
    const { tenant } = useAppParameters();
    const t = useTranslations();
    const [updateModalOpen, setUpdateModalOpen] = useState(false);

    const handleOpenUpdateModal = () => {
        setUpdateModalOpen(true);
    };

    const handleCloseUpdateModal = () => {
        setUpdateModalOpen(false);
    };

    const handleProceed = () => {
        handleCloseUpdateModal();
        onEdit();
    };

    return (
        <>
            <CollapsablePanel
                label={selectedRisk.name}
                collapsable={false}
                addon={
                    <TextButton preventDefault onClick={handleOpenUpdateModal}>
                        {t('general.edit')}
                    </TextButton>
                }>
                <div className="px-6 py-2">
                    <Heading className="mb-4" level="h4">
                        {t('eshop.home.summary.insuranceConditions')}
                    </Heading>
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                        <ReadOnlyField label={t('eshop.home.summary.insurancePeriodLabel')}>
                            {t('eshop.home.months', { count: 12 })}
                        </ReadOnlyField>
                        <ReadOnlyField label={t('eshop.home.summary.totalPriceLabel')}>
                            {formatEuroValue(totalPrice, tenant)}
                        </ReadOnlyField>
                    </div>
                </div>
            </CollapsablePanel>

            <UpdateModal
                updateModalOpen={updateModalOpen}
                handleCloseUpdateModal={handleCloseUpdateModal}
                navigateToStep={handleProceed}
            />
        </>
    );
}
